export const goathouse = [
  {
    date: "16 มีนาคม 2569",
    title:
      "แบบโรงเรือนแพะ",
    url: "https://drive.google.com/file/d/1Eq2419AevGN3-CNdSxx0oIDk4NKPiQ-O/view?usp=drive_link",
  },
  {
    date: "16 มีนาคม 2569",
    title:
      "คู่มือโรงเรือนแพะ",
    url: "https://drive.google.com/file/d/1cs2J7XRYObIeN7G3mXfgIoDE72dS8FEK/view?usp=drive_link",
  },
];
